// extracted by mini-css-extract-plugin
export default {"simpleBtn":"SimpleButton_simpleBtn__sI7TL"};